/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./aiSpeech.vue?vue&type=template&id=79896e01&scoped=true&"
import script from "./aiSpeech.vue?vue&type=script&lang=js&"
export * from "./aiSpeech.vue?vue&type=script&lang=js&"
import style0 from "./aiSpeech.vue?vue&type=style&index=0&id=79896e01&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79896e01",
  null
  
)

export default component.exports